import get from 'lodash/get';


export function getIsLoading(state, key) {
  return get(state, ['loading', key]);
}
